import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Exige access token vigente. Si no hay sesión, redirige a Keycloak.
 * Las rutas públicas no deben usar este guard.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  auth.ensureAuthenticatedSession();
  return auth.isAuthenticated();
};
